	jQuery(document).ready(function ($) {
			var accordions = $(".accordion");
			if (accordions.length > 0) {
			var lastAccordion = accordions.last();
			if (lastAccordion.hasClass("color-lilac")) {
			$(".footer").addClass("color-orange icons-show");}
	}
});
